export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || obj.errand_number;
};
export const detailUrl = ({ id, isGov = false }) => {
  if (isGov) return `/authority-errands/${id}`;

  return `/rounding-errands/${id}`;
};

export const overviewUrl = ({ isGov = false }) => {
  if (isGov) return `/authority-errands/`;

  return `/rounding-errands/`;
};

export const editUrl = ({ authInspection, id }) => {
  if (authInspection) {
    return `/authority-errands/edit/${id}`;
  }
  return `/rounding-errands/edit/${id}`;
};

export const createUrl = () => {
  return `/rounding-errands/create`;
};

export const createAuthErrandUrl = ({ id }) => {
  return `/authority-errands/create/${id}`;
};

export const allUrl = () => {
  return `/rounding-errands/all`;
};

export const getRoundingOverviewStatsProcessName = () => {
  return `ROUNDING_ERRAND_OVERVIEW_STATS`;
};
